<script>
import { get } from 'vuex-pathify'
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'

export default {
	mixins: [checkoutMixin],
	data() {
		return {
			activeForm: 'signup',
			accountEmail: '',
			loading: false,
			showLoginForm: false,
			areUserModeButtonsHidden: false,
			useFastSignup: false,
			validation: {},
			initialGuestEmail: '',
		}
	},
	computed: {
		user: get('shop/user'),
		guestUser: get('shop/guestUser'),
		guestMode() {
			return this.$srv('CheckoutOptions.guestMode')
		},
		userModeButtonsHidden() {
			return this.guestMode && this.$srv('CheckoutOptions.userModeButtonsHidden')
		},
	},
	watch: {
		user(value) {
			if (value) this.checkout.stepSubmit()
		},
		guestUser(value) {
			if (value) this.checkout.stepSubmit()
		},
	},
	methods: {
		handleSubmit() {
			if (!this.accountEmail) return
			if (this.useFastSignup) {
				this.fastEmailSignup()
			} else if (this.initialGuestEmail.toLowerCase() == this.accountEmail.toLowerCase()) {
				this.checkout.stepSubmit()
			} else {
				this.guestEmailSignup()
			}
		},
		async guestEmailSignup() {
			this.$shopApi.post({
				url: '/user/guest-signup',
				loading: (v) => (this.loading = v),
				data: {
					accountEmail: this.accountEmail,
				},
				onValidation: ({ validation }) => (this.validation = validation),
				onSuccess: ({ data }) => {
					this.$store.set('shop/guestUser', data.user)
					this.onSignup(data)
				},
			})
		},
		async fastEmailSignup() {
			this.$shopApi.post({
				url: '/user/fast-signup',
				loading: (v) => (this.loading = v),
				data: {
					accountEmail: this.accountEmail,
				},
				onValidation: ({ validation }) => (this.validation = validation),
				onSuccess: ({ data }) => {
					this.$store.set('shop/user', data.user)
					this.onSignup(data)
				},
				onError: () => {
					this.areUserModeButtonsHidden = false
				},
			})
		},
		onSignup({ loginMethod, user, contextId }) {
			this.$eventer().trigger('user:signup', { loginMethod, user })
			if (contextId != this.$srv('contextId')) {
				window.location.reload()
				return new Promise((resolve) => setTimeout(resolve, 1000 * 60))
			}
		},
	},
	mounted() {
		this.areUserModeButtonsHidden = !!this.userModeButtonsHidden
		this.accountEmail = this.guestUser?.accountEmail || ''
		this.initialGuestEmail = this.accountEmail
	},
}
</script>

<template>
	<div v-if="showLoginForm">
		<Button outlined text @click="showLoginForm = false">
			<v-icon small left>mdi-arrow-left</v-icon> Atrás
		</Button>
		<LoginForms v-model="activeForm" />
	</div>
	<div v-else class="d-flex align-center flex-column" style="gap: 16px; max-width: 330px; margin: 0 auto">
		<template v-if="guestMode">
			<div class="text-center">
				<div class="font-weight-bold">Ingresa solo con tu email</div>
				<div class="grey--text text--darken-2" style="line-height: 1; font-size: 0.9rem">
					Ingresá tu email sin necesidad de crear una cuenta.
				</div>
			</div>
			<div>
				<Validator :validation="validation" :keys-filter="(k) => k.replace(/^user\./, '')">
					<TextField
						class="w100 mb-1"
						outlined
						label="Email"
						dense
						:loading="loading"
						v-model="accountEmail"
					/>
				</Validator>
				<v-checkbox v-model="useFastSignup" dense hide-details>
					<template #label> Crear mi cuenta con este correo </template>
				</v-checkbox>
				<div class="grey--text pl-8" style="font-size: 0.9rem; line-height: 1">
					Te enviaremos la informacion para acceder a tu cuenta
				</div>
			</div>

			<Button class="w100" color="success" @click="handleSubmit">Continuar</Button>
			<v-divider class="w100" />
			<Button
				v-if="userModeButtonsHidden && areUserModeButtonsHidden"
				@click="areUserModeButtonsHidden = false"
				class="w100"
				color="primary"
				text
			>
				Ingresa con tu cuenta
				<v-icon right small>mdi-chevron-down</v-icon>
			</Button>
		</template>

		<div
			:class="{ 'd-none': areUserModeButtonsHidden, 'd-flex': !areUserModeButtonsHidden }"
			class="align-center flex-column"
			style="gap: 16px; max-width: 330px; margin: 0 auto"
		>
			<div class="text-center">
				<div class="font-weight-bold">Ingresá o Registrate como usuario</div>
				<div class="grey--text text--darken-2" style="line-height: 1; font-size: 0.9rem">
					Al crear una cuenta, guardaremos tu historial de compras, tus direcciones y tus datos de
					contacto para que no tengas que volver a ingresarlos en futuras compras.
				</div>
			</div>
			<GoogleAuthButton :custom-btn-props="{ width: '330px' }" />
			<Button
				@click="
					showLoginForm = true
					activeForm = 'login'
				"
				class="w100"
				color="primary"
				:outlined="!!guestMode"
			>
				{{ guestMode ? 'Ingresa con tu cuenta o Registrate' : 'Ingresa con tu cuenta' }}
			</Button>
			<Button
				v-if="!guestMode"
				@click="
					showLoginForm = true
					activeForm = 'signup'
				"
				class="w100"
				color="primary"
				outlined
			>
				Crear nueva cuenta
			</Button>
		</div>
	</div>
</template>

<style scoped>
.google-btn-hover-overlay:hover {
	background-color: rgba(255, 255, 255, 0.24);
	cursor: pointer;
}
</style>

